import { connect } from 'react-redux';

import { getCompositionDraft, getOngoingChat, getWidgetType, isClientReady } from 'app/modules';
import { trackOnboardingSubmitted } from 'events/analytics';
import { WIDGET_TYPES } from 'enums/configuration';
import authOrCreateMessage from 'actions/messages/authOrCreateMessage';
import checkAuth from 'actions/user/checkAuth';
import Composition from 'presentation/components/Composition';
import configSelectors from 'selectors/configuration';
import uiEvents from 'events/ui';
import updateCustomerTypingState from 'actions/session/updateCustomerTypingState';
import userEvents from 'events/user';

export const mapStateToProps = (state, props) => {
  const isSelfService = getWidgetType(state) === WIDGET_TYPES.SELF_SERVICE;
  const onboardingEnabled = configSelectors.getOnboardingEnabled(state.configuration);
  const isOnboarding = (isSelfService || onboardingEnabled) && !isClientReady(state);
  return {
    ...props,
    compositionDraft: getCompositionDraft(state),
    isOnboarding,
    isSelfService,
    prompt: getOngoingChat(state).compositionPlaceholder,
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    onSubmit: message => {
      dispatch(uiEvents.updateCompositionDraft(''));
      dispatch(authOrCreateMessage(message));
    },
    onChange: text => {
      dispatch(uiEvents.updateCompositionDraft(text));
    },
    onCustomerTypingStateUpdate: typingState => {
      dispatch(updateCustomerTypingState(typingState));
    },
    onOnboard: email => {
      // track analytics event
      dispatch(trackOnboardingSubmitted());

      dispatch(uiEvents.updateCompositionDraft(''));
      //just saves the user in the store and generates an ID
      dispatch(userEvents.createOnboardingUser({ email }));
      //now auth again because we have an ID
      dispatch(checkAuth);
    },
  };
};

const CompositionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Composition);

export default CompositionContainer;
